import { axiosGet } from '../axios/axios.config';

export const searchContactAuditLogs = async (data) => {
  const response = await axiosGet('data/api/types/contact/audit-logs', data);
  return response;
};

export const searchAuditLogs = searchContactAuditLogs;
